import * as amplitude from '@amplitude/analytics-browser';
let amplitudeInitialized = false;
let configFetchAttempted = false;
export const AMPLITUDE_EVENTS = {
    APP_VIEWED: 'sm_unified_ui_app_viewed',
    FLEET_HISTORY_FETCH_SUCCEEDED: 'sm_unified_ui_fleet_history_fetch_succeeded',
    FLEET_HISTORY_FETCH_FAILED: 'sm_unified_ui_fleet_history_fetch_failed',
    FLEET_HISTORY_DOWNLOAD_STARTED: 'sm_unified_ui_fleet_history_download_started',
    FLEET_HISTORY_DOWNLOAD_SUCCEEDED: 'sm_unified_ui_fleet_history_download_succeeded',
    FLEET_HISTORY_DOWNLOAD_FAILED: 'sm_unified_ui_fleet_history_download_failed',
    VEHICLE_EXPANDED_FETCH_SUCCEEDED: 'sm_unified_ui_vehicle_expanded_fetch_succeeded',
    VEHICLE_EXPANDED_FETCH_FAILED: 'sm_unified_ui_vehicle_expanded_fetch_failed',
    VEHICLE_EXPANDED_DOWNLOAD_CLICKED: 'sm_unified_ui_vehicle_expanded_download_clicked',
    VEHICLE_EXPANDED_DOWNLOAD_SUCCEEDED: 'sm_unified_ui_vehicle_expanded_download_succeeded',
    VEHICLE_EXPANDED_DOWNLOAD_FAILED: 'sm_unified_ui_vehicle_expanded_download_failed',
    VEHICLE_TILE_FETCH_SUCCEEDED: 'sm_unified_ui_vehicle_tile_fetch_succeeded',
    VEHICLE_TILE_FETCH_FAILED: 'sm_unified_ui_vehicle_tile_fetch_failed',
    VEHICLE_TILE_VIEW_ALL_CLICKED: 'sm_unified_ui_vehicle_tile_view_all_clicked',
    SERVICE_BOOKING_WIDGET_VIEWED: 'sm_unified_ui_service_booking_widget_viewed',
    SERVICE_BOOKING_FIND_DEALER_CLICKED: 'sm_unified_ui_service_booking_find_dealer_clicked',
};
function getHostUserContext() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.serviceManagementEnv?.USER;
}
const SM_CONFIG_URLS = [
    'https://www.stage-servicemgmt.fordpro.com/config.json',
    'https://www.dev-servicemgmt.fordpro.com/config.json',
    'https://www.servicemgmt.fordpro.com/config.json',
];
function getAmplitudeApiKey() {
    if (typeof window !== 'undefined' && window.serviceManagementEnv?.AMPLITUDE_API_KEY) {
        return window.serviceManagementEnv.AMPLITUDE_API_KEY;
    }
    return process.env.AMPLITUDE_API_KEY ?? '';
}
// Fetches config.json from SM UI domain when running as MFE remote (index.template.html never runs)
async function fetchConfigFromSmDomain() {
    if (typeof window === 'undefined' || typeof fetch === 'undefined')
        return;
    const hostname = window.location.hostname;
    const isStage = hostname.includes('stage-servicemgmt') || hostname.includes('fcsfleet-stage');
    const isDev = hostname.includes('dev-servicemgmt') || hostname.includes('fcsfleet-dev');
    let configUrl;
    if (isStage) {
        configUrl = SM_CONFIG_URLS[0];
    }
    else if (isDev) {
        configUrl = SM_CONFIG_URLS[1];
    }
    else {
        configUrl = SM_CONFIG_URLS[2];
    }
    try {
        const res = await fetch(configUrl);
        if (!res.ok)
            return;
        const cfg = await res.json();
        if (typeof window !== 'undefined') {
            window.serviceManagementEnv = { ...(window.serviceManagementEnv ?? {}), ...cfg };
        }
    }
    catch {
        // config.json unavailable — Amplitude will not initialize
    }
}
export function initializeAmplitudeSdk() {
    if (amplitudeInitialized) {
        return;
    }
    const apiKey = getAmplitudeApiKey();
    if (!apiKey) {
        // Running as MFE remote — fetch config.json from SM UI domain (once only)
        if (!configFetchAttempted) {
            configFetchAttempted = true;
            void fetchConfigFromSmDomain().then(() => {
                const retryKey = getAmplitudeApiKey();
                if (retryKey)
                    initializeAmplitudeSdk();
            });
        }
        return;
    }
    try {
        const user = getHostUserContext();
        amplitude.init(apiKey, user?.userId, {
            defaultTracking: true,
        });
        const userProperties = {};
        if (user?.userType) {
            userProperties.userType = user.userType;
        }
        if (user?.companyInfo?.companyId) {
            userProperties.companyId = user.companyInfo.companyId;
        }
        if (user?.companyInfo?.companyName) {
            userProperties.companyName = user.companyInfo.companyName;
        }
        if (Object.keys(userProperties).length > 0) {
            const identifyObj = new amplitude.Identify();
            for (const [key, value] of Object.entries(userProperties)) {
                identifyObj.set(key, value);
            }
            amplitude.identify(identifyObj);
        }
        amplitudeInitialized = true;
    }
    catch {
        // Analytics failures should never impact user workflows.
    }
}
export function trackAmplitudeEvent(eventName, eventProperties) {
    if (!amplitudeInitialized) {
        return;
    }
    try {
        amplitude.track(eventName, eventProperties);
    }
    catch {
        // Analytics failures should never impact user workflows.
    }
}
